import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { redistributePennies } from '../utilities';
import { calculateBogoDiscounts } from './index';

export function redistributeDiscountToCart({
  keysToApplyDiscount,
  detailsSorted,
  bogoCalcsData,
  products,
  discountTaxOrder,
  bottleDepositTaxCentsTotal,
  cannabisTaxTotal,
  salesTaxTotal,
  productTotal,
  avoidTaxes,
  residualPrice,
  credit,
  bogoRewardsApplied,
  compositePrice,
  stowedDiscounts,
  receiptDetail,
  globalSpecialsSettings,
}) {
  _.forEach(keysToApplyDiscount, (key) => {
    const detailToDiscount = _.find(detailsSorted, ({ key: detailKey }) => detailKey === key);
    const applicableDiscountToCartReward = bogoCalcsData?.applicableRewards?.[detailToDiscount.key] || [];

    const itemBasePrice = detailToDiscount.mixAndMatch?.adjustedBasePrice || detailToDiscount.basePrice;
    const itemPrice = itemBasePrice.times(detailToDiscount.quantity);
    const itemQtyWholesalePrice = detailToDiscount.wholesalePrice.times(detailToDiscount.quantity);
    const itemWhPrice = itemQtyWholesalePrice.round(2, 1);
    const itemProductNonArmsLength = products[detailToDiscount.key].product.nonArmsLength;

    let itemBottleDepositTaxCents = Big(0);
    let itemCannabisTax = Big(0);
    let itemSalesTax = Big(0);
    let itemResidual = Big(0);

    if (discountTaxOrder === 'both' || discountTaxOrder === 'taxesFirst') {
      itemBottleDepositTaxCents = detailToDiscount.bottleDepositTaxCents.times(detailToDiscount.quantity);
      itemCannabisTax = detailToDiscount.cannabisTax(itemPrice, itemWhPrice, itemProductNonArmsLength) || Big(0);
      itemSalesTax = detailToDiscount.salesTax(itemPrice, itemWhPrice, itemProductNonArmsLength) || Big(0);
      ({ cannabisTax: itemCannabisTax, salesTax: itemSalesTax, residual: itemResidual } = redistributePennies({
        itemCannabisTax,
        itemPrice,
        itemSalesTax,
      }));
    }

    if (discountTaxOrder === 'taxesFirst') {
      // If the tax is taken before the discount then add it into the subtotal much
      // as we do above with the discount.
      if (Big(detailToDiscount.basePriceMult, 'Base Price Mult').eq(1)) {
        bottleDepositTaxCentsTotal = bottleDepositTaxCentsTotal.add(itemBottleDepositTaxCents);
        cannabisTaxTotal = cannabisTaxTotal.add(itemCannabisTax);
        salesTaxTotal = salesTaxTotal.add(itemSalesTax);
      } else {
        // Unclear how to deal with residual taxes in this case.
        productTotal = productTotal.add(itemCannabisTax).add(itemSalesTax).add(itemBottleDepositTaxCents.div(100));
        avoidTaxes = true;
      }
      residualPrice = residualPrice.add(itemResidual);
    }

    const itemPostTaxPrice = itemPrice
      .plus(itemCannabisTax)
      .plus(itemSalesTax)
      .plus(itemBottleDepositTaxCents.div(100));
    const itemCompositePrice = discountTaxOrder === 'taxesFirst' ? Big(itemPostTaxPrice) : Big(itemPrice);
    const itemIndividualPrice =
      discountTaxOrder === 'taxesFirst' ? itemPostTaxPrice.div(detailToDiscount.quantity) : Big(itemBasePrice);

    // we need to remove the previously added credit from the discount to cart
    credit = credit.minus(detailToDiscount.bogoSavings?.total || Big(0));

    ({ bogoRewardsApplied, compositePrice, credit, productTotal, stowedDiscounts } = calculateBogoDiscounts({
      applicableBogoRewards: applicableDiscountToCartReward,
      applyStowedDiscounts: false,
      bogoRewardsApplied,
      compositePrice: itemCompositePrice,
      credit,
      detail: detailToDiscount,
      discountTaxOrder,
      dtcIndividualPrice: itemIndividualPrice,
      productTotal,
      receiptDetail,
      globalSpecialsSettings,
      stowDiscounts: false,
      stowedDiscounts: [],
    }));
  });
  return {
    bottleDepositTaxCentsTotal,
    cannabisTaxTotal,
    salesTaxTotal,
    productTotal,
    avoidTaxes,
    residualPrice,
    credit,
    bogoRewardsApplied,
    compositePrice,
    stowedDiscounts,
  };
}
